import { Component, OnInit } from '@angular/core';
import { ToastService } from '../../../services/notification/toast.service';
import { WebService}  from '../../../services/web/web.service';
import {SpinnerService} from '../../../services/spinner/spinner.service';
import {ActivatedRoute, Router} from '@angular/router';
import {PlanService} from "../plan.service";
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {PaymentPopupComponent} from '../payment-popup/payment-popup.component';
import {Location} from '@angular/common';
import {SecurityService} from "../../../services/security.service";
import { shouldShowPaymentButton } from '../../../shared/utils/onboarding-payment-status';

@Component({
    selector: 'app-my-plans',
    templateUrl: './my-plans.component.html',
    styleUrls: ['./my-plans.component.scss'],
    standalone: false
})
export class MyPlansComponent implements OnInit {
    public urlCliente: string = '';
    private onboardingConfigID: any;
    public myplans: any = [];
    showPaymentButton: Boolean = false;
    isActive: boolean = false;

    constructor(private securityService: SecurityService,
                private location: Location,
                private dialog: MatDialog,
                private planService: PlanService,
                private router: Router,
                private activateRoute: ActivatedRoute,
                private toast: ToastService,
                private spinner: SpinnerService,
                private webService: WebService) {
    }


    ngOnInit(): void {
        this.planService.plans.subscribe(plans => {

            // BUSCAMOS TODOS LOS BANCOS
            let partner = -1;
            if (this.securityService.getTokenPartner() != null || this.securityService.getTokenPartner() != undefined) {
                partner = this.securityService.getTokenPartner()
            }

            // NICO
            this.activateRoute.params.subscribe(params => {
                this.webService.get(this.webService.HOST + "/onboardingConfig/" + params["id"] + "?partner=" + partner).subscribe(response => {
                    this.urlCliente = response.result.url_client;
                    this.isActive = response.result.active;

                }, err => {
                })
            })


            if (plans.length > 0) {
                this.myplans = [];
                this.myplans.push(...plans);
            } else {
                this.goCreatePlan();
            }

        })
        this.activateRoute.params.subscribe(params => {
            this.onboardingConfigID = params['id'];
            this.getConfigByID();
        }, err => {
            this.toast.showError(err);
        });

    }

    getConfigByID() {
        this.spinner.open();

        let partner = -1;
        if(this.securityService.getTokenPartner() != null || this.securityService.getTokenPartner() != undefined){
            partner = this.securityService.getTokenPartner()
        }

        this.webService.get(this.webService.HOST + "/onboardingConfig/" + this.onboardingConfigID + "?partner=" + partner).subscribe(config => {
            this.spinner.close();

            this.showPaymentButton = shouldShowPaymentButton(config);

            console.log("PASA POR AQUI ANTES DE CARGAR LOS PLANES");
            this.planService.plans.emit(config.result.plans)
        }, err => {
            this.spinner.close();
            this.toast.showError(err);
            setTimeout(() => {
                this.location.back();
            }, 2000); // 3000 milliseconds = 3 seconds
        });
    }

    goCreatePlan() {
        this.router.navigate(['create'], {relativeTo: this.activateRoute, queryParamsHandling: "preserve"});
    }


    goBack() {
        this.router.navigate([".."], {relativeTo: this.activateRoute, queryParamsHandling: "preserve"}); // ENVIAMOS AL CLIENTE PARA EL STEP2
    }

    goToPortals() {
        this.router.navigate(["/my-portals"], {relativeTo: this.activateRoute, queryParamsHandling: "preserve"});
    }

    processPayment() {
        let dialogRef: MatDialogRef<any> = this.dialog.open(PaymentPopupComponent, {
            width: '90vw',
            maxWidth: '1200px',
            maxHeight: '90vh',
            disableClose: true,
            data: {configID: this.onboardingConfigID}
        })
        dialogRef.afterClosed()
            .subscribe(res => {
                if (res != undefined && res == 1) {// SOLO SI ES COBRADO
                    this.router.navigateByUrl("/congratulation");
                }
            })
    }


}
